import a from "./isObject.js";
var r = Object.create, u = function() {
  function e() {
  }
  return function(t) {
    if (!a(t))
      return {};
    if (r)
      return r(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
const o = u;
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseCreate.js
// module id = 1424
// module chunks = 41